import {
    IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonLoading,
    IonPage, IonSelect, IonSelectOption, IonTitle, IonToast, IonToolbar, useIonViewDidEnter
} from '@ionic/react';
import { Buffer } from 'buffer';
import { arrowBack } from 'ionicons/icons';
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { listaEquipePorPerfil } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';

const TotemConfiguracoes: React.FC = () => {
    const history = useHistory();
    const { loja } = useContext(MessageContext);
    const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

    const [listaTotens, setListaTotens] = useState<any[]>([]);
    const [totemSelecionado, setTotemSelecionado] = useState<string>("");
    const [showLoading, setShowLoading] = useState(true);
    const [showToast, setShowToast] = useState(false);
    const [textToast, setTextToast] = useState("");

    useIonViewDidEnter(() => {
        setEsconderMenu(true);
    });

    useEffect(() => {
        const salvo = window.localStorage.getItem("totemSelecionado") || "";
        setTotemSelecionado(salvo);
        carregarTotens();
    }, []);

    async function carregarTotens() {
        try {
            setShowLoading(true);
            const token = window.localStorage.getItem("token") || "";
            const montarUrl = listaEquipePorPerfil.url
                .replace("{loja}", loja.replaceAll(/#/g, "%23"))
                .concat("?status=ativo&lojas=" + Buffer.from(loja).toString('base64'));

            const resp = await fetch(montarUrl.replace("{perfil}", "totem"), {
                method: "GET",
                headers: [["token", token]],
                credentials: 'include'
            });

            if (resp.status === 400 || resp.status === 401) {
                history.replace("/login/");
                return;
            }

            const result = await resp.json();
            if (result?.Items) {
                setListaTotens(result.Items);
            }
        } catch (e) {
            console.error("Erro ao carregar totens:", e);
        } finally {
            setShowLoading(false);
        }
    }

    function salvar() {
        if (!totemSelecionado) {
            setTextToast("Selecione um totem.");
            setShowToast(true);
            return;
        }

        const totem = listaTotens.find((t: any) => t.pk === totemSelecionado);
        window.localStorage.setItem("totemSelecionado", totemSelecionado);
        window.localStorage.setItem("totemSelecionadoNome", totem?.nome || "Totem");

        setTextToast("Totem salvo com sucesso.");
        setShowToast(true);
        history.goBack();
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="danger">
                    <IonButtons slot="start">
                        <IonButton onClick={() => { history.goBack(); }}>
                            <IonIcon slot="icon-only" icon={arrowBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>Configurações Totem</IonTitle>
                </IonToolbar>
            </IonHeader>

            <IonContent className="ion-padding">
                <IonList>
                    <IonItem>
                        <IonLabel position="stacked">Totem selecionado</IonLabel>
                        <IonSelect
                            interface="popover"
                            placeholder="Selecione o totem"
                            value={totemSelecionado}
                            onIonChange={(e) => setTotemSelecionado(e.detail.value)}
                        >
                            {listaTotens.map((totem: any) => (
                                <IonSelectOption key={totem.pk} value={totem.pk}>
                                    {totem.nome || totem.pk}
                                </IonSelectOption>
                            ))}
                        </IonSelect>
                    </IonItem>
                </IonList>

                <IonLoading isOpen={showLoading} spinner='circles' />
                <IonToast
                    isOpen={showToast}
                    position="middle"
                    onDidDismiss={() => setShowToast(false)}
                    message={textToast}
                    duration={3000}
                />
            </IonContent>

            <IonFooter className="ion-no-border" >
                <IonToolbar>
                    <IonButton expand="block" size='large' color="danger" onClick={salvar}>
                        Confirmar
                    </IonButton>
                </IonToolbar>
            </IonFooter>
        </IonPage>
    );
};

export default TotemConfiguracoes;
